module.exports = __webpack_public_path__ + "static/media/spicam.0d552a1c.jpg";